exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.grid-title h4 {\n  margin-top: 7px;\n}\n.table-bordered th {\n  background-color: var(--primary-color);\n  color: white;\n  border: 0 !important;\n}\n", ""]);

// exports
